import { TrustAPI } from '@/shared/modules/trust-api';
import { AccountingAppView } from '@/shared/modules/typescript-trustapi-client/models';
import { Options, Vue } from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import AddEditAccountingSoftwareModal from './add-edit-modal/index.vue';
import { orderBy } from "lodash";
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import AccountingSoftwareAuditTrailModal from './accounting-software-audit-trail-modal/index.vue';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
@Options({
  components: {
    AddEditAccountingSoftwareModal,
    AccountingSoftwareAuditTrailModal,
    LoadingIndicator,
    ErrorIndicator
  }
})
export default class TrustDataAccountingSoftware extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private tableHeadings = [
    { text: 'Name', value: 'name', sortable: false },
    { text: 'Certified', value: 'certified', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Show in ATCS', value: 'isShowInAtcs', sortable: false},
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private selectedAccountSoftware: AccountingAppView = {
    id: null,
    name: null,
    description: null,
    status: null,
    certifiedType: null,
  };

  private searchKeyword = '';
  private showActiveOnly = true;
  private showAddEditModal = false;
  private showAuditTrailModal = false;
  private loadingContent = false;
  private errorLoadingContent = false;


  private accountingSoftwareList: AccountingAppView[] = [];

  created(): void {
    this.loadAccountSoftwareList();
  }

  mounted() {
    this.eventCtrl.on('reload-accounting-software', this.loadAccountSoftwareList);
  }

  beforeUnmount() {
    this.eventCtrl.off('reload-accounting-software', this.loadAccountSoftwareList);
  }

  private async loadAccountSoftwareList(): Promise<void> {
    try {
      this.loadingContent = true;
      this.errorLoadingContent = false;
      const body: any = {
        'skip': null,
        'take': null,
        'keyword': this.searchKeyword
      } as any;
  
      const resp: any =
        await this.apiService.AccountingAppApi?.apiV2AccountingAppGetAccountingAppsPost(body, false);
        this.accountingSoftwareList = resp.data.data as AccountingAppView[];
        this.accountingSoftwareList = orderBy(
          this.accountingSoftwareList,
          [data => data.name.toLowerCase()],
          ['asc']
        );
    } catch (err) {
      this.errorLoadingContent = true;
      console.log(err);
    } finally {
      this.loadingContent = false;
    }
  }

  private editAccountingSoftware(accountingApp: AccountingAppView): void {
    this.selectedAccountSoftware = accountingApp;
    this.showAddEditModal = true;
  }

  private addAccountingSoftware(): void {
    this.selectedAccountSoftware = {
      id: 0,
      name: '',
      description: null,
      status: null
    };

    this.showAddEditModal = true;
  }
  
  private viewAccountingSoftwareAuditTrail(accountingApp: AccountingAppView): void {
    this.selectedAccountSoftware = accountingApp;
    this.showAuditTrailModal = true;
  }

  get filteredSoftwareList(): AccountingAppView[] {
    let accAppList: AccountingAppView[] = this.accountingSoftwareList;
    if (this.showActiveOnly) {
      accAppList = this.accountingSoftwareList.filter(
        x => x.status.name == 'Active'
      );
    }

    if (this.searchKeyword.trim()) {
      accAppList = this.accountingSoftwareList.filter(
        x => x.name.toLocaleLowerCase().includes(this.searchKeyword.toLocaleLowerCase())
      );
    }

    return accAppList;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }
}
